import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hobi",
  "description": "",
  "published": "2006-11-16T00:00:00.000Z",
  "redirect_from": ["/blog/hobi/swizec/355"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nekateri ljudje izberejo najbolj cudne stvari za hobije. Vzemimo za primer te zmesane gimnasticarje, imajo stiri ure treningov na dan, pet dni v tednu in kjer bi mi temu rekli tezko, naporno delo, oni temu pravijo odlicen sproscujoc hobi in ga opravljajo iz ciste ljubezni do ... cesarkoli jim je pac vsec pri vsem skupaj.`}</p>
    <p>{`Tu je torej na vse zmesane norce v svetu in stvari, ki jih pocno. `}{`*`}{`dvigne kelih`}{`*`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      